import React, { useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Formik } from "formik";
import { useTranslation, Trans } from "react-i18next";
import "bootstrap/dist/css/bootstrap.min.css";
import "./newresetpassword.module.css";

// services (old page)
import { fetchUser, login, updatePassword } from "../../services/auth";

// reducers (old page)
import { setLoading, setRole, setUpAuth } from "../../reducer/auth/auth";
import { setUser } from "../../reducer/userSlice";
import { userType } from "../../utils/utils";
import LanguageSwitcher from "../../components/languageSwitcher";

const NewResetPassword = () => {
  // hooks
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation("authLogin");
  const [searchParams] = useSearchParams();

  // URL params (from old page)
  const urlToken = searchParams.get("token");
  const urlEmail = searchParams.get("email");

  // states (keep UI exactly same)
  const [emailError, setEmailError] = useState("");
  const [showModal, setShowModal] = useState(false); // register selection modal (new UI)
  const [typePass, SetTypePass] = useState(true);
  const [confirmtypePass, SetTypeconfirmPass] = useState(true);

  // store last successful form values so Login button can use them
  const [savedValues, setSavedValues] = useState(null);

  useEffect(() => {
    // keep any optional UI carousel logic if required
    // window.loadCarousel && window.loadCarousel();
  }, []);

  // ----- Modal functions for register modal (new UI) -----
  const openRegistrationModal = () => {
    setShowModal(true);
    // keep legacy bootstrap helper if present
    window.loadModal2 && window.loadModal2("#myModal", "show");
  };

  useEffect(() => {
    const modalEl = document.getElementById("myModal");
    if (!modalEl) return;
    const handleHide = () => setShowModal(false);
    modalEl.addEventListener("hidden.bs.modal", handleHide);
    return () => modalEl.removeEventListener("hidden.bs.modal", handleHide);
  }, []);

  const redirectRoute = (item) => {
    navigate(item);
  };

  const changePassType = () => SetTypePass(!typePass);
  const changePassTypeConfirm = () =>
    SetTypeconfirmPass(!confirmtypePass);

  // ----- OLD PAGE: RunSubmitHandler -> updatePassword -----
  const RunSubmitHandler = async (formData) => {
    dispatch(setLoading(true));
    let item = {
      email: urlEmail,
      passwordToken: urlToken,
      password: formData.new_password,
      password_confirmation: formData.confirm_password,
    };

    updatePassword(item)
      .then((data) => {
        dispatch(setLoading(false));
        if (data.data.status) {
          // save values for Login action and show success modal
          setSavedValues(formData);
          window.loadModal2("#successModal", "show");
          // Use existing global helper if available, else fallback to showing modal via Bootstrap
          if (window.openModal) {
            window.openModal(); // legacy from old page (keeps compatibility)
          } else if (window.loadModal2) {
            

          } else {
            // fallback: manually show success modal via DOM (bootstrap)
            const el = document.getElementById("successModal");
            if (el) {
              // bootstrap modal show if available
              let modal = null;
              if (
  window.bootstrap &&
  window.bootstrap.Modal &&
  typeof window.bootstrap.Modal.getOrCreateInstance === "function"
) {
  modal = window.bootstrap.Modal.getOrCreateInstance(el);
}
              modal && modal.show();
            }
          }
        } else {
          // handle API-side errors if present
          if (data.data && data.data.error) {
            setEmailError(data.data.error);
          }
        }
      })
      .catch((err) => {
        dispatch(setLoading(false));
        console.log(err);
      });
  };

  // ----- OLD PAGE: LOGIN USER AFTER RESET (called when user clicks Login in success modal) -----
  const LoginUser = async (formData) => {
    if (!formData) return;
    localStorage.removeItem("guest_id");
    dispatch(setLoading(true));
    let item = {
      email: urlEmail,
      password: formData.new_password,
    };
    login(item)
      .then((data) => {
        dispatch(setLoading(false));
        if (data.data.status) {
          localStorage.setItem("access_token", data.data.data.access_token);
          dispatch(setUpAuth());
          callProfile(data.data.data.access_token);
        } else {
          // optional error handling
          // setEmailError("Unable to login after reset");
        }
      })
      .catch((err) => {
        dispatch(setLoading(false));
        console.log(err);
      });
  };

  // ----- OLD PAGE: fetchUser & redirect based on role -----
  const callProfile = async (token) => {
    dispatch(setLoading(true));
    await fetchUser(token)
      .then((data) => {
        dispatch(setLoading(false));
        dispatch(setUser(data.data.data));
        renderUserType(data.data.data.usertype, data.data.data);
      })
      .catch((err) => {
        dispatch(setLoading(false));
        console.log(err);
      });
  };

  const renderUserType = (type, users) => {
    const user = userType(type);
    dispatch(setRole(user));
    if (user === "medium") {
      if (users.status === 1 && users.medium_status === 1) {
        navigate("/dashboard");
      } else {
        navigate("/profile");
      }
    } else if (user === "admin") {
      navigate("/dashboard");
    } else if (user === "client") {
      if (users.is_first_appointment) {
        navigate("/appointments");
      } else {
        navigate("/dashboard");
      }
    } else {
      // fallback
      navigate("/dashboard");
    }
  };

  // ======= SVG Icon (keep UI same) =======
  const PasswordIcon = () => (
    <svg
      className="input-icon"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z"
        stroke="#6c757d"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11"
        stroke="#6c757d"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  // ======= RENDER (UI unchanged; Formik field names wired to new_password / confirm_password) =======
  return (
    <>
      <div className="login_body">
        <div className="header_login">
          <div className="header_container">
            <div className="header_left">
              <div className="logo">
                <img src="/images/logo-verysoul.png" alt={t("shared.logoAlt")} />
              </div>
            </div>
            <div className="header_right">
              <LanguageSwitcher className="header-language-switcher" />
              <span className="desktop-text">{t("shared.noAccount")}</span>
              <span className="mobile-text"></span>
              <button className="register-btn" onClick={openRegistrationModal}>
                {t("shared.register")}
              </button>
            </div>
          </div>
        </div>

        {/* Main Content Section (UI preserved) */}
        <div className="container-fluid login_content">
          <div className="row justify-content-center login_row">
            <div className="card_column col-md-6 text-white bg-dark login_left_area">
              <div className="card-body text-center">
                <div className="login_inner">
                  <div className="text-center login-heading">
                    <h2 className="d-none-text d-md-block real-text">{t("shared.tagline")}</h2>
                    <h2 className="d-block d-md-none"><Trans i18nKey="shared.taglineMultiline" ns="authLogin" t={t} /></h2>
                  </div>
                </div>
              </div>
            </div>

            <div className="card_column col-md-6 p-4 mb-0 login_right_area">
              <div className="login_inner">
                <div className="card-body">
                  <h1>{t("resetPassword.title")}</h1>

                  {emailError && (
                    <div className="alert alert-danger" role="alert">
                      {emailError}
                    </div>
                  )}

                  <Formik
                    initialValues={{
                      new_password: "",
                      confirm_password: "",
                    }}
                    validate={(values) => {
                      const errors = {};
                      if (!values.new_password) {
                        errors.new_password = t("common:validation.required");
                      }
                      if (values.new_password && values.new_password.length < 6)
                        errors.new_password = t("shared.minPassword");

                      if (values.new_password !== values.confirm_password)
                        errors.confirm_password = t("resetPassword.passwordMismatch");

                      if (!values.confirm_password)
                        errors.confirm_password = t("common:validation.required");

                      return errors;
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                      RunSubmitHandler(values);
                      setSubmitting(false);
                    }}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      isSubmitting,
                    }) => (
                      <form className="login_form" onSubmit={handleSubmit}>
                        <div className="mb-4 mt-4 form-group">
                          <label>{t("shared.passwordLabel")}</label>
                          <div className="position-relative password-field-wrapper">
                            <div className="input-icon-wrapper">
                              <PasswordIcon />
                            </div>
                            <input
                              className={`form-control ${
                                errors.new_password &&
                                touched.new_password &&
                                errors.new_password
                                  ? "error-boundry"
                                  : ""
                              }`}
                              type={typePass ? "password" : "text"}
                              name="new_password" // wired to Formik
                              placeholder={t("shared.passwordPlaceholder")}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.new_password}
                            />
                            <div
                              className="password-toggle"
                              onClick={changePassType}
                            >
                              <img
                                src={
                                  typePass
                                    ? "/images/eye.png"
                                    : "/localImages/openeye.svg"
                                }
                                alt={t("shared.togglePassword")}
                                className={`eye-icon pointer ${
                                  typePass ? "" : "openeye"
                                }`}
                              />
                            </div>
                          </div>
                          {errors.new_password && touched.new_password && (
                            <div className="error-text">
                              {errors.new_password}
                            </div>
                          )}
                        </div>

                        <div className="mb-4 mt-4 form-group">
                          <label>
                            {" "}
                            {t("resetPassword.confirmPasswordLabel")}<i>*</i>
                          </label>
                          <div className="position-relative password-field-wrapper">
                            <div className="input-icon-wrapper">
                              <PasswordIcon />
                            </div>
                            <input
                              className={`form-control ${
                                errors.confirm_password &&
                                touched.confirm_password &&
                                errors.confirm_password
                                  ? "error-boundry"
                                  : ""
                              }`}
                              type={confirmtypePass ? "password" : "text"}
                              name="confirm_password" // wired to Formik
                              placeholder={t("shared.passwordPlaceholder")}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.confirm_password}
                            />
                            <div
                              className="password-toggle"
                              onClick={changePassTypeConfirm}
                            >
                              <img
                                src={
                                  confirmtypePass
                                    ? "/images/eye.png"
                                    : "/localImages/openeye.svg"
                                }
                                alt={t("shared.togglePassword")}
                                className={`eye-icon pointer ${
                                  confirmtypePass ? "" : "openeye"
                                }`}
                              />
                            </div>
                          </div>
                          {errors.confirm_password &&
                            touched.confirm_password && (
                              <div className="error-text">
                                {errors.confirm_password}
                              </div>
                            )}
                        </div>

                        <div className="row">
                          <div className="col-12">
                            <button
                              className="btn btn-primary px-4 login_button"
                              type="submit"
                              disabled={isSubmitting}
                            >
                              {t("resetPassword.submit")}
                            </button>
                          </div>
                        </div>
                      </form>
                    )}
                  </Formik>

                  <p className="text-body-secondary text-center mt-3">
                    <Link to="/login">{t("shared.backToLogin")}</Link>
                  </p>
                </div>

                <div className="login_bottom_area mt-4">
                  <div className="login_bottom_content">
                    <div className="login_bottom_links">
                      <ul>
                        <li>
                          <Link to="/privacy-policy" target="_blank">
                            {t("common:common.privacyPolicy")}
                          </Link>
                        </li>
                        <li>
                          <Link to="/terms-conditions" target="_blank">
                            {t("common:common.termsConditions")}
                          </Link>
                        </li>
                      </ul>
                    </div>
                    <p className="text- bookin">
                      <b>
                        {t("common:common.browserNote")}
                      </b>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* SUCCESS MODAL (separate id so it doesn't conflict with register modal) */}
      <div
        className="modal fade"
        id="successModal"
        role="dialog"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-preview">
          <div className="modal-content">
            <div className="modal-body text-center">
              <div className="icon-pop">
                <img src="/images/Union-icon.png" alt="Union-icon" />
              </div>
        
              <p className="mt-4">
                <Trans i18nKey="resetPassword.successModal.body" ns="authLogin" t={t} />
              </p>
              <div
                className="update-password-btn"
                onClick={() => {
                  // hide modal then login
                  window.loadModal2("#successModal", "hide");
                  LoginUser(savedValues);
                }}
                data-dismiss="modal"
              >
                {t("resetPassword.successModal.login")}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* REGISTER SELECTION MODAL (NEW UI) - unchanged visually */}
      {showModal && (
        <div className="dont-have-acc" onClick={() => setShowModal(false)}>
          <div
            className="modal fade"
            id="myModal"
            role="dialog"
            data-bs-backdrop="true"
            data-bs-keyboard="true"
          >
            <div
              className="modal-dialog modal-dialog-preview"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="modal-content">
                <div className="modal-body text-align-unset">
                  <div className="icon-pop text-align-center">
                    <img src="/images/Union-icon.png" alt="union-icon" />
                  </div>
                  <ul>
                    <li>
                      <div
                        onClick={() => redirectRoute("/registration")}
                        className="height-unset"
                        data-dismiss="modal"
                      >
                        <img src="/images/medum.png" alt="medium" />
                        <span data-dismiss="modal">
                          <Trans i18nKey="shared.registerAsMedium" ns="authLogin" t={t} />
                        </span>
                      </div>
                    </li>
                    <li>
                      <div
                        className="height-unset"
                        onClick={() => redirectRoute("/register-client")}
                        data-dismiss="modal"
                      >
                        <img src="/images/customer.png" alt="register" />
                        <span>
                          <Trans i18nKey="shared.registerAsClient" ns="authLogin" t={t} />
                        </span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NewResetPassword;
